import styled from "@emotion/styled"
import TextField from "../Radiate/TextField/TextField"
import Table from "../Radiate/Table/Table"

export const RadioButtonBorder = styled.div`
  border: 2px solid ${(props) => props.selected ? props.theme.primary : props.theme.gray2};
  border-radius: 14px;
  width: 28px;
  height: 28px;
  position: relative ;
  cursor: pointer;

`
export const RadioButton = styled.div`
  height: 16px;
  width: 16px;
  border-radius: 8px;
  background: ${(props) => {
  if (props.selected) {
    return props.theme.primary
  }
  return "transparent"
  }};
  position: absolute ;
  top: 4px;
  left: 4px;

`

export const NameTextField = styled(TextField)`
  
`

export const StyledTable = styled(Table)`
  .name {
    width: 300px;
  }

  [class='locales,id'] {
    width: 450px;
  }
`